export default __webpack_public_path__ + "static/media/yen.6cea9a20.svg";